import MsLanguageValueObj from "./MsLanguageValueObj";
export default class MsLanguageValueObjList {
  constructor(name, initialValue, namespace, languageCode, languageVarietyName, region, script, variant, isEditor=false) {
    this.namespace = namespace;
    this.name = name;
    this.languageCode = languageCode;
    this.languageVarietyName = languageVarietyName;
    this.region = region;
    this.script = script;
    this.variant = variant;
    this.isEditor = isEditor;
    this.languagesList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getLanguagesList() {
    return this.languagesList;
  }

  setLanguagesList(flanguagesList) {
    this.languagesList = flanguagesList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.languagesList.length) {
      return;
    }
    this.languagesList.splice(index, 1);
  }

  cleanVariants(language) {
    if (language.variant && Array.isArray(language.variant.list)) {
      language.variant.list = language.variant.list.filter((variant) => variant.value !== undefined);
    }
    return language;
  }

  addValueObj(obj) {
    const language = new MsLanguageValueObj(this.name, obj, this.namespace, this.languageCode, this.languageVarietyName, this.region, this.script, this.variant);
    // const newLanguage = this.cleanVariants(language);
    this.languagesList.push(language);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      if (!obj && this.isEditor) { // if it is undefined - either it is empty coming from editor ,
        // either it is empty coming from landing page. both need different handling
        this.addValueObj(obj);
      }
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.languagesList.length; index++) {
      const languageItem = this.languagesList[index];
      expandedList.push(languageItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.languagesList.length; index++) {
      const languageItem = this.languagesList[index];
      condition = condition && languageItem.isEmpty();
    }
    return condition;
  }
}
